import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { BoxV2, ButtonUI, ModalUI } from 'sonata-react-components';

import { AdvertiserSelector } from '@/components/common/AdvertiserSelector';
import { useModals } from '@/router';

import './modal.scss';

import type { MediaAdvertiserUserInterface } from 'sonata-static-storage/lib/schemas/mediaInfo/mediaAdvertiserUser.schema';

type State = {
  advertiser?: MediaAdvertiserUserInterface;
};

export default function CampaignPlanModal() {
  const location = useLocation();
  const { formatMessage } = useIntl();
  const modals = useModals();
  const modalRef: any = useRef();
  const createToken = useRef({} as Record<string, any>);

  const [{ advertiser }, setState] = useState<State>({});

  useEffect(() => {
    modalRef?.current?.openModal();
  }, [modalRef]);

  useEffect(() => {
    return () => {
      createToken.current?.cancel?.();
    };
  }, []);

  const handleCreateCPButtonClick = () => {
    modals.open('/campaigns/new/campaignPlanSettingsModal', {
      at: {
        pathname: '/campaigns',
        search: location.search
      },
      state: {
        advertiser,
        modalId: 'campaignPlanSettings-modal'
      }
    });
  };

  const handleAdvertiserChange = (adv: MediaAdvertiserUserInterface) => {
    setState(prev => ({
      ...prev,
      advertiser: adv
    }));
  };

  const handleClose = () =>
    modals.close({
      at: {
        pathname: '/campaigns',
        search: location.search
      }
    });

  return (
    <ModalUI
      centerButton={
        <ButtonUI
          disabled={!advertiser}
          icon="fa fa-arrow-right"
          iconPosition="right"
          id="cpSettingsBtn"
          onClick={handleCreateCPButtonClick}
          shape="squareRounded"
          text={formatMessage({
            defaultMessage: 'Go to Campaign Plan creation',
            id: 'campaignPlans.modal.createCpButton'
          })}
          type="primary"
        />
      }
      closeModalCallback={handleClose}
      ref={modalRef}
      title={formatMessage({
        defaultMessage: 'Create Campaign Plan',
        id: 'campaignPlans.modal.title.create'
      })}
      width="805px"
    >
      <div className="campaignPlanModal">
        <div className="campaignPlanModal__row">
          <BoxV2 id="campaignPlanModal__description">
            <BoxV2.Body bgColor="multiFlightBackground01" className="bodyTiny alignLeft fontRegular" padding="8px 12px">
              {formatMessage({
                defaultMessage: 'Select the campaign plan',
                id: 'campaignPlans.modal.descriptionCP'
              })}
            </BoxV2.Body>
          </BoxV2>
          <div className="entitySelectorsGrid">
            <div>
              <AdvertiserSelector id="campaignPlanModalAdvertiserSelector" onChange={handleAdvertiserChange} />
            </div>
          </div>
        </div>
      </div>
    </ModalUI>
  );
}
